import { css, cx } from 'emotion';
import React from 'react';
import { ActiveCarot } from './ActiveCarot';
import { filterName } from './shared/styles';
import { theme } from '../../../Theme';
import SortOrderList from '@jetshop/ui/SortOrder/SortOrderList';
import t from '@jetshop/intl';
import { buttonStyle } from './ListAccordion';

const sortStyle = css`
  button {
    ${buttonStyle};
    svg use {
      fill: ${theme.colors.green};
    }
  }
`;

export function SortAccordion({ sortOrders, accordionProps, idx = 0 }) {
  const { AccordionContent } = accordionProps;
  const accordionIsOpen = accordionProps.openIndexes.includes(idx);

  return (
    <div className={cx(sortStyle, 'sort-accordion')}>
      <div
        className={filterName}
        onClick={() => accordionProps.handleClick(idx)}
      >
        {t('Sort by')}
        <ActiveCarot isOpen={accordionIsOpen} />
      </div>
      <AccordionContent isOpen={accordionIsOpen}>
        <SortOrderList sortOrders={sortOrders} />
      </AccordionContent>
    </div>
  );
}
